import { Button } from '@chakra-ui/react'
import React from 'react'

const DeliveredButton = () => {
  return (
    <Button bgColor={"rgba(8, 170, 88, 1)"} adding="0 20px " borderRadius="35px">Delivered</Button>
  )
}

export default DeliveredButton